module.exports = __webpack_public_path__ + "img/ae948e25d7afdc12a16fdf6cab71fdd5.svg";